import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import TabNavigation from '../components/shared/TabNavigation'

import MyProfilePage from './MyProfilePage'
import SettingsTeachers from './SettingsTeachersPage'
// import SettingsDoormen from './SettingsDoormanPage'
import SettingsClassrooms from './SettingsClassroomsPage'
import SettingsLayout from './SettingsLayoutPage'
import SettingsCovers from './SettingsCoversPage'
import ModerationPage from './ModerationPage'
import CoordinatorPage from './SettingsCoordinatorsPage'
import {
  accessSettings,
  accessStudentsAndClassrooms,
  accessForAdmins,
  accessForVersarAdmin
} from '../utils/constants'
import HistoryAccessPage from './HistoryAccessPage'

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Montserrat, Source Sans Pro',
    width: '98%',
    marginTop: 40
  },
  headOptions: {
    overflowY: 'hidden',
    borderBottom: '2px solid #CED6E0',
    paddingLeft: 24,
    display: 'flex',
    gap: 24
  },
  optionPath: {
    cursor: 'pointer',
    color: '#8080808C',
    fontWeight: 600,
    paddingBottom: 8,
    fontSize: '16px'
  },
  selectedOption: {
    position: 'relative',
    color: '#375F92',
    fontWeight: 700,
    '&::after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      bottom: -0.5,
      width: '100%',
      height: 2,
      backgroundColor: '#386093'
    }
  },
  tab_navigation: {
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'flex-end !important',
    marginBottom: 0
  },
  tab_navigation_key_class: {
    marginBottom: '12px !important'
  }
}))

const SettingsPage = props => {
  const { currentOccupation } = props
  const classes = useStyles()
  const history = useHistory()

  const optionsPaths = [
    {
      label: 'Meu perfil',
      path: '/settings',
      permission: accessSettings,
      component: <MyProfilePage {...props} history={history} />,
      style: { flex: '0 0 115px' }
    },
    {
      label: 'Turmas e alunos',
      path: '/settings/classrooms',
      permission: accessStudentsAndClassrooms,
      component: <SettingsClassrooms {...props} />,
      style: { flex: '0 0 170px' }
    },
    {
      label: 'Professores',
      path: '/settings/teachers',
      permission: accessStudentsAndClassrooms,
      component: <SettingsTeachers {...props} />,
      style: { flex: '0 0 130px' }
    },
    // {
    //   label: 'Controlador',
    //   path: '/settings/doorman',
    //   permission: accessStudentsAndClassrooms,
    //   component: <SettingsDoormen {...props} />,
    //   style: { flex: '0 0 130px' }
    // },
    {
      label: 'Coordenadores',
      path: '/settings/coordinator',
      permission: accessStudentsAndClassrooms,
      component: <CoordinatorPage {...props} />,
      style: { flex: '0 0 160px' }
    },
    {
      label: 'Configurações de usuários',
      path: '/settings/historic',
      permission: accessForAdmins,
      component: <HistoryAccessPage {...props} />,
      style: { flex: '0 0 250px' }
    },
    {
      label: 'Moderação',
      path: '/settings/moderation',
      permission: accessForAdmins,
      component: <ModerationPage {...props} />,
      style: { flex: '0 0 120px' }
    },
    {
      label: 'Capas',
      path: '/settings/covers',
      permission: accessForVersarAdmin,
      component: <SettingsCovers {...props} />,
      style: { flex: '0 0 90px' }
    },
    {
      label: 'Layout',
      path: '/settings/layout',
      permission: accessForAdmins,
      component: <SettingsLayout {...props} />,
      style: { flex: '0 0 90px' }
    }
  ]

  const getOptionIndex = () => {
    return optionsPaths.findIndex(item => item.path === props.location.pathname)
  }

  return (
    <div className={classes.root}>
      <TabNavigation
        keyClass={classes.tab_navigation_key_class}
        emptyOptions={1}
        flexFixedLayout
        baseClass={classes.tab_navigation}
        defaultOption={getOptionIndex()}
        options={optionsPaths
          .filter(item => item.permission.includes(currentOccupation))
          .map((item, index) => {
            return {
              id: index,
              key: item.label,
              style: item.style,
              handleChange: () => history.push(item.path)
            }
          })}
      />
      <div>
        {
          optionsPaths.find(item => item.path === props.location.pathname)
            ?.component
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    currentOccupation: state.auth.currentOccupation?.[0]
  }
}

export default connect(mapStateToProps)(SettingsPage)
